import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { useMemo } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { Documento } from "../../../../../rh/domain/models/documento";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { GenerateDocumentoColumnsDefinition } from "../columns";
import { Header } from "./header";
import { Description } from "@mui/icons-material";


type Props = {
  open: boolean,
  saving: boolean,
  loading: boolean,
  onDownload: (idFuncionarioArquivo: number, imageName: string) => void,
  onClose: () => void,
  onSetCadastroDocumentosOpenState: (id: number | null, openState: boolean) => void,
  onStartDeleteDocumentos: (id: number, openState: boolean) => void;
  DocumetosLista: Documento[];
  situacao: number;
  status: number;
  pesquisa: string | Date | null,
  NomeDocumento: string | null,
  DataDe: Date | null,
  DataAte: Date | null,
  onDataRangeChange: (de: Date | null, ate: Date | null) => void,
  handleClearFilters: () => void;
  handleStatus: (v: number) => void,
  handleSituacao: (v: number) => void,
  handleNomeDocumento: (v: string | null) => void,
};

export const DocumentoModal = ({
  open,
  saving,
  loading,
  DocumetosLista,
  onDownload,
  onClose,
  onSetCadastroDocumentosOpenState,
  onStartDeleteDocumentos,
  situacao,
  status,
  pesquisa,
  DataDe,
  DataAte,
  onDataRangeChange,
  handleClearFilters,
  handleStatus,
  handleSituacao,
  handleNomeDocumento,
  NomeDocumento,
}: Props) => {
  const centroDocumentosColumnsDefinition = useMemo(() => {
    return GenerateDocumentoColumnsDefinition({
      onActionEdit: (idDocumento) => onSetCadastroDocumentosOpenState(Number(idDocumento), true),
      onActionDelete: (idDocumento) => onStartDeleteDocumentos(Number(idDocumento), true),
      onDownload: (idDocumento, imageName) => onDownload(idDocumento, imageName),
    });
  }, [onDownload, onSetCadastroDocumentosOpenState, onStartDeleteDocumentos]);

  const tabelaDocumentos = useMemo(() => {
    return (
      <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
        <StyledDataGrid
          tableName="Documentos Diversos"
          disableColumnMenu={false}
          getRowId={(row: Documento) => row.idDocumento}
          columns={centroDocumentosColumnsDefinition}
          loading={loading}
          autoHeight={true}
          textSize="medio"
          getRowHeight={() => "auto"}
          rows={DocumetosLista}
          rowCount={DocumetosLista.length}

        />
      </div>
    );
  }, [DocumetosLista, centroDocumentosColumnsDefinition, loading]);


  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={false}
      sx={{
        "& .MuiDialog-paper": {
          width: "95vw",
          maxWidth: "none",
          height: "90vh",
          maxHeight: "none",
        },
      }}>
      <DialogTitle className="flex items-center gap-3 border-b border-gray-200 pb-4">
        <div className="w-10 h-10 bg-green-50 rounded-full flex items-center justify-center text-[#00a859]">
          <Description style={{ fontSize: 22 }} />
        </div>
        <span className="text-lg font-bold text-gray-800">
          Tabela de documentos
        </span>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 12,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <DynamicIcon nameIcon="Close" size={24} />
      </IconButton>
      <DialogContent>
        <ModalLoading loading={saving}>
          <>
            <div className="w-full flex flex-row justify-between items-center mt-8 mb-2">
              <div></div>
              <div>
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  sx={{ px: 2 }}
                  onClick={() => onSetCadastroDocumentosOpenState(null, true)}>
                  Novo
                </PrimaryButton>
              </div>
            </div>
            <Header
              onClearFilters={handleClearFilters}
              handleStatus={handleStatus}
              handleSituacao={handleSituacao}
              status={status}
              situacao={situacao}
              pesquisa={pesquisa}
              NomeDocumento={NomeDocumento}
              handleNomeDocumento={handleNomeDocumento}
              DataDe={DataDe}
              DataAte={DataAte}
              onDataRangeChange={onDataRangeChange}
            />
            {tabelaDocumentos}
          </>
        </ModalLoading>
      </DialogContent>
    </Dialog>
  );
}